import { render, staticRenderFns } from "./firstDepositModal.vue?vue&type=template&id=68de6934"
import script from "./firstDepositModal.vue?vue&type=script&lang=js"
export * from "./firstDepositModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports